import React, { useEffect } from 'react';

export const useAfterPaintEffect = (effect: any, dependencies: any[]) => {
    useEffect(() => { requestAnimationFrame(() => { setTimeout(() => { effect(); }, 0); }); }, dependencies);
}